export default __webpack_public_path__ + "static/media/msit.bc81391d.png";